import ddt from '@wix/da-ddt';
import { reduxKey } from './constants';
import noop from '../../utils/noop';
function getState(state) {
    if (!state[reduxKey]) {
        return {};
    }
    return state[reduxKey];
}
// Auth
export var getChatAuthToken = function (state) { return getState(state).chatAuthToken; };
export var getShowOverlayChatList = function (state) {
    return getState(state).showOverlayChatList || false;
};
export var getShowOverlayNewChatWindow = function (state) {
    return getState(state).showOverlayNewChatWindow || false;
};
export var getNewChatParticipants = function (state) {
    return getState(state).newChatParticipants;
};
export var getPendingNewChatMessage = function (state) {
    return getState(state).pendingNewChatMessage;
};
export var isChatReduxReady = function (state) { return !!state[reduxKey]; };
// Chat list data
export var getChatListSubscriptionState = function (state) {
    return getState(state).chatListSubscriptionState;
};
export var getChatListError = function (state) {
    return getState(state).chatListSubscriptionStateError;
};
export var getChatListFetchMore = function (state) { var _a, _b; return _b = (_a = getState(state).chatListSubscription) === null || _a === void 0 ? void 0 : _a.fetchMore, (_b !== null && _b !== void 0 ? _b : noop); };
export var getChatListChats = function (state) { return getState(state).chats; };
export var getChatListStatus = function (state) { return getState(state).chatsStatus; };
export var getChatUnreadCount = function (state) { var _a; return ((_a = getState(state).globalUnreadCount) === null || _a === void 0 ? void 0 : _a.count) || 0; };
export var getOpenChatrooms = function (state) { return getState(state).chatrooms; };
export var getOpenChatroomsOrder = function (state) {
    return getState(state).openChatroomsOrder;
};
var defaultChatroomValue = {};
export var getChatroom = function (state, chatId) {
    var chatrooms = getState(state).chatrooms;
    if (chatrooms && chatrooms.hasOwnProperty(chatId)) {
        return chatrooms[chatId];
    }
    else {
        ddt.log('chat', "We tried to get a chatroom that wasn't inside of our store -- chatroom id [" + chatId + "]");
        return defaultChatroomValue;
    }
};
//# sourceMappingURL=selectors.js.map